// @flow
import React from 'react'
import { Link } from '@paypalcorp/pp-react'

type ButtonLinkProps = {
  style?: Object,
  children: any,
}

/**
 * Use the pp-react Link component as button and remove button styling.
 */
export default function ButtonLink({
  style = {},
  children,
  ...rest
}: ButtonLinkProps) {
  return (
    <Link
      as="button"
      type="button" // replace default "type=submit" in forms.
      data-pagename="" // fix lint issue
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Link>
  )
}
